import { BaseCrudService } from "@/services/base";
import { PresenceResult } from "@/swagger/models";
import { PresenceReportInput } from "@/swagger/models/presence-report-input";

class PresenceService extends BaseCrudService<PresenceResult, PresenceReportInput> {
    z;
    constructor() {
        super({
            apiPrefix: "reports/presence",
            entityName: "presence report",
        });
    }

    async getReport(input: PresenceReportInput) {
        try {
            const res = await this.axios.get<PresenceResult[]>(``, {
                params: input,
            });
            return res.data;
        } catch (e) {
            this.tosti.error({
                message: `Could not generate report: ${e.response?.data?.message || e.message}`,
            });
        }
    }
}

export const presenceService = new PresenceService();
